var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, ginni } from '@shapeable/utils';
import { every, mapValues, omit, reduce } from 'lodash';
import { EntityDataGrid } from '../entities/entity-data-grid';
import { isNewRow } from '../select/utils/is-new-row';
var cls = classNames('form-field-linked-junction');
export var FormFieldLinkedJunctionDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isChromeless = _a.isChromeless;
    return isChromeless && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(EntityDataGrid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
  // Dialog: styled(EntityTypeCreateForm)`${DialogStyles}`,
};
export var FormFieldLinkedJunction = function (props) {
  var className = props.className,
    isChromeless = props.isChromeless,
    entityTypeDefinition = props.entityTypeDefinition,
    onChange = props.onChange;
  var value = props.value || [];
  ginni.verbose.log("DATA GRID VALUE", value);
  // console.log("FormFieldLinkedJunction", { entityTypeDefinition });
  var handleChange = function (args) {
    var e_1, _a;
    var items = args.items,
      mutatedRows = args.mutatedRows,
      deletedRows = args.deletedRows;
    ginni.group("FormFieldLinkedJunction handleChange");
    ginni.verbose.log("args", args);
    // here we need to produce cascaded mutations
    var cascadedMutations = reduce(mutatedRows, function (acc, row, rowId) {
      var isNew = isNewRow(rowId);
      var mutationValues = mapValues(row, function (row) {
        var _a;
        return (_a = row.mutationValue) !== null && _a !== void 0 ? _a : row.value;
      });
      var mutation = {
        entityTypeName: entityTypeDefinition.name,
        refId: rowId,
        type: isNew ? 'Create' : 'Patch',
        input: omit(mutationValues, 'id')
      };
      acc.push(mutation);
      // console.log("FormFieldLinkedJunction handleChange reduce", { acc, row, rowId });
      return acc;
    }, []);
    try {
      // now process the deleted rows
      for (var _b = __values(args.deletedRows), _c = _b.next(); !_c.done; _c = _b.next()) {
        var rowId = _c.value;
        var mutation = {
          entityTypeName: entityTypeDefinition.name,
          type: 'Delete',
          refId: rowId,
          input: {}
        };
        cascadedMutations.push(mutation);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    var mutationValue = items.map(function (item) {
      return item.id;
    });
    var isValid = every(mutatedRows, function (row) {
      // let's specifically look for false, as undefined should probably be regarded as valid
      return every(row, function (_a) {
        var isValid = _a.isValid;
        return isValid !== false;
      });
    });
    // ginni.log("FormFieldLinkedJunction cascadedMutations", { cascadedMutations });
    var onChangeResult = {
      value: items,
      mutationValue: mutationValue,
      cascadedMutations: cascadedMutations,
      isValid: isValid
    };
    ginni.verbose.log("onChangeResult", onChangeResult);
    ginni.groupEnd();
    onChange(onChangeResult);
  };
  if (!entityTypeDefinition) {
    return null;
  }
  // console.log("FormFieldLinkedJunction", { entityTypeDefinition });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Grid, {
    onChange: handleChange,
    isChromeless: isChromeless,
    showBorder: !isChromeless,
    items: value,
    defn: entityTypeDefinition
  }));
};
FormFieldLinkedJunction.cls = cls;
FormFieldLinkedJunction.defaultProps = FormFieldLinkedJunctionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;